import Global from '../stores/global'
import Tenant from '../stores/tenant'
import Channel from './../stores/channel'
import Job from './../stores/job'
import Notifications from './../stores/notifications'
import Users from '../stores/users'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store(Global)

store.registerModule('tenant', Tenant)
store.registerModule('channel', Channel)
store.registerModule('job', Job)
store.registerModule('notifications', Notifications)
store.registerModule('users', Users)
